<script lang="ts">
	// Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { AdvancedCard } from '@Shelly/shelly-design-system';
	//Helper
	import { getBthomeButtonValue } from 'src/helpers/virtual_helpers/virtual_bthome_helper';
	import { real_id } from 'src/helpers/interface_helpers';
	//Components
	import VirtualButton from './VirtualButton.svelte';
	//Stores
		import { getDeviceStatus, getDeviceSettings, readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	//Types
	import type { VirtualComponentInterface } from 'src/types/VirtualComponents';
	import type { Device } from 'src/types/Device';

	$: statusStore = getDeviceStatus(device.id);
	export let component: VirtualComponentInterface;
	export let device: Device;

	$: valueData = getBthomeButtonValue(
		$statusStore,
		component?.config,
		component?.idx || 0,
	);
</script>

{#if valueData}
	<AdvancedCard
		size="m"
		class="mb-s ml-xs mr-xs"
		title={$format('input_type_button', {
			default: 'Button',
		}) + (component?.buttons > 1 ? ` (${component?.idx || 0})` : '')}
		avatar={{
			icon: 'fas fa-cube',
		}}
	>
		<svelte:fragment slot="right">
			<VirtualButton
				{device}
				componentID={component.id}
				value={valueData.event}
				icon={valueData.icon}
				disabled={valueData.isBleButton}
			/>
		</svelte:fragment>
	</AdvancedCard>
{/if}
